import { Popover, PopoverProps, styled } from '@mui/material';

import { Card, tokens } from '@cast/design-system';

const HeaderPopperCard = styled(Card, {
  name: 'DsCard',
  slot: 'Root',
  overridesResolver: (_, styles) => {
    return [styles.popper];
  },
})(() => ({
  borderRadius: '4px 4px 0 0',
  boxShadow: tokens.theme.shadows.elevation.medium,
  padding: 0,
}));

HeaderPopperCard.displayName = 'HeaderPopperCard';

export const HeaderPopover = ({
  children,
  testId,
  ...props
}: PopoverProps & { testId?: string }) => {
  return (
    <Popover
      {...props}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: -10,
        horizontal: 'right',
      }}
      disableScrollLock
    >
      <HeaderPopperCard testId={testId}>{children}</HeaderPopperCard>
    </Popover>
  );
};
